import React, { useEffect, useState } from 'react';
import AddressSearch from 'react-loqate';
import { Form } from "react-bootstrap"
import $ from "jquery"


const AddressSearchInput = (props) => {

    function addresstype() {
        //$("input[name=addressPostalCode]").val('');
    }


    return (
        <Form.Group className="text form-group">
            <div className="custom-float">
               
                <input
                    name="address"
                    placeholder="Your Postcode *"
                    autocomplete="off"
                    type="text"
                    id="address"
                    class="form-control"
                    {...props}
                    value={props.addressLabel}
                    required="true"
                    onkeyup={addresstype()}
                />

            </div>
        </Form.Group>
    );
};

const AddressSearchInputVipForm = (props) => {

    function addresstype() {
        //$("input[name=addressPostalCode]").val('');
    }


    return (
        <Form.Group className="text form-group">
            <div className="custom-float">
                <input
                    name="address"
                    placeholder="Current Address *"
                    autocomplete="off"
                    type="text"
                    id="address"
                    class="form-control"
                    {...props}
                    value={props.addressLabel}
                    required="true"
                    onkeyup={addresstype()}
                />

            </div>
        </Form.Group>
    );
};

export default function Addresssearch(props) {
    const selectAddressval = (address) => {
        const hanldePostCode=  props?.hanldePostCode && props?.hanldePostCode(address);
        document.getElementById('address').value = (address.Label).replace(/\n/g, ", ")

        document.getElementById('addressBuildingName').value = address.BuildingName
        document.getElementById('addressBuildingNumber').value = address.BuildingNumber
        document.getElementById('addressPostalCode').value = address.PostalCode
        document.getElementById('addressSubBuilding').value = address.SubBuilding
        document.getElementById('addressStreet').value = address.Street

        sessionStorage.setItem('addressBuildingName', address.BuildingName)
        sessionStorage.setItem('addressBuildingNumber', address.BuildingNumber)
        sessionStorage.setItem('addressPostalCode', address.PostalCode)
        sessionStorage.setItem('addressSubBuilding', address.SubBuilding)
        sessionStorage.setItem('addressStreet', address.Street)

    }
    
    const componenet = props.componentType === "Vip_Page" ? AddressSearchInputVipForm : AddressSearchInput
    return (
        <AddressSearch
            locale="en_GB"
            apiKey={process.env.GATSBY_LOQATE_API_KEY}
            countries={['GB']}
            components={{ Input: componenet }}
            inputClassname="address form-control"
            listClassname="address-options"
            listItemClassname="address-option"
      onSelect={ address => selectAddressval(address) }

        />
    )
}